import api from "@/plus/api";
import store from "@/store";
import { MessageBox } from "element-ui";
import auth from "plus/auth";

const master = (q) =>
  require.ensure([], () => q(require("../views/index")), "bundle");

function checkIsExternalLink(url) {
  return url.indexOf("http") > -1;
}

export default async function(router, routes) {
  const res = await api.login.getLoginInfo();
  window.localStorage.setItem(
    "groupIdAndGroupNameDtos",
    JSON.stringify(res.data.data.groupIdAndGroupNameDtos)
  );

  const {
    menuInfoList,
    menuInfoListPermission,
    userInfo,
    realName,
    userId,
    deptName,
  } = res.data.data;
  if (menuInfoListPermission)
    auth.menuInfoListPermission = menuInfoListPermission;
  if (userInfo) auth.userInfo = userInfo;
  await store.dispatch("updateUserInfo", { realName, userId, deptName });

  if (!menuInfoList.length) {
    MessageBox.alert("您的账号没有任何菜单权限", "提示", {
      confirmButtonText: "重试",
      confirmButtonClass: "confirmBtn",
      showClose: false,
      callback: () => {
        window.location.reload();
      },
    });
    return false;
  }

  const rootRouter = menuInfoList.map((items) => {
    return {
      name: items.menuUrl,
      component: () => import(`../views/${items.menuUrl}/index.vue`),
      path: items.menuUrl,
      meta: {
        title: items.menuName,
        isShow: items.isShow,
        icon: items.icon,
      },
      children: items.children.map((item) => {
        if (checkIsExternalLink(item.menuUrl)) {
          return {
            name: item.menuUrl,
            path: item.menuUrl,
            meta: {
              isExternal: true,
              title: item.menuName,
              isShow: item.showInMenu,
              icon: item.icon,
            },
          };
        }
        return {
          name: item.menuUrl,
          component: () =>
            import(`../views/${item.menuUrl.replace(/\./g, "/")}.vue`),
          path: `/${item.menuUrl.replace(/\./g, "/")}`,
          meta: {
            title: item.menuName,
            isShow: item.showInMenu,
            icon: item.icon,
          },
        };
      }),
    };
  });

  router.addRoutes([
    {
      name: "home",
      path: "/",
      component: master,
      // redirect: rootRouter[0].children[0].name,
      children: [
        {
          path: "/work/index/homeIndex",
          name: "work.index.homeIndex",
          meta: {
            title: "首页",
            isShow: true,
          },
          component: () => import("../views/work/index/homeIndex"),
        },
        ...rootRouter,
      ],
      meta: { auth: true, title: "首页" },
    },
    // {
    //     name: 'pageNotFound',
    //     path: '*',
    //     component: pageNotFound
    // }
  ]);

  await store.dispatch("updateMenus", rootRouter);

  return true;
}
